// src/pages/PaymentCancel.tsx
// Shown when the user cancels out of the BOG payment page.
// No charge has been made. Offers to retry (opens PaymentModal) or go home.

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePaymentStore } from '../stores/usePaymentStore';

const C = {
  text:   '#f1f5f9',
  muted:  '#8b9cc4',
  accent: '#4f8cf7',
  warn:   '#fbbf24',
};

export default function PaymentCancel() {
  const navigate        = useNavigate();
  const openPaymentModal = usePaymentStore((s) => s.openModal);

  const [retryHover, setRetryHover] = useState(false);
  const [homeHover,  setHomeHover]  = useState(false);

  return (
    <div style={{
      minHeight: '100vh', background: '#080c14',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '24px',
      fontFamily: 'system-ui, -apple-system, "Segoe UI", sans-serif',
    }}>
      <div style={{
        background: 'rgba(255,255,255,0.03)',
        border: '1px solid rgba(255,255,255,0.06)',
        borderRadius: '24px',
        padding: '52px 44px',
        maxWidth: '440px',
        width: '100%',
        textAlign: 'center',
        backdropFilter: 'blur(20px)',
        boxShadow: '0 32px 64px rgba(0,0,0,0.4)',
      }}>
        {/* Warning icon */}
        <div style={{
          width: '72px', height: '72px', borderRadius: '50%',
          background: 'rgba(251,191,36,0.1)',
          border: '1px solid rgba(251,191,36,0.25)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          margin: '0 auto 28px',
        }}>
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#fbbf24" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
        </div>

        <h1 style={{ fontSize: '1.8rem', fontWeight: 900, color: C.text, margin: '0 0 14px' }}>
          Payment Cancelled
        </h1>

        <span style={{
          display: 'inline-block',
          padding: '5px 16px', borderRadius: '999px',
          background: 'rgba(52,211,153,0.1)',
          border: '1px solid rgba(52,211,153,0.25)',
          color: '#34d399', fontSize: '0.8rem', fontWeight: 700,
          marginBottom: '20px',
        }}>
          No charge was made
        </span>

        <p style={{ fontSize: '0.92rem', color: C.muted, margin: '0 0 36px', lineHeight: 1.7 }}>
          No worries — your free access to Unit 1 is still available.
          Whenever you're ready, you can subscribe to unlock all units.
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          <button
            style={{
              padding: '14px', borderRadius: '999px',
              background: retryHover
                ? 'linear-gradient(135deg, #6366f1 0%, #4f8cf7 100%)'
                : 'linear-gradient(135deg, #4f8cf7 0%, #6366f1 100%)',
              color: '#fff', fontWeight: 800, fontSize: '0.95rem',
              border: 'none', cursor: 'pointer', fontFamily: 'inherit',
              transition: 'transform 0.2s ease, box-shadow 0.2s ease',
              transform: retryHover ? 'translateY(-2px)' : 'none',
              boxShadow: retryHover ? '0 12px 28px rgba(79,140,247,0.3)' : 'none',
            }}
            onMouseEnter={() => setRetryHover(true)}
            onMouseLeave={() => setRetryHover(false)}
            onClick={() => { navigate('/'); openPaymentModal(); }}
          >
            Try Again
          </button>

          <button
            style={{
              padding: '13px', borderRadius: '999px',
              background: 'transparent',
              color: homeHover ? C.text : C.muted,
              fontWeight: 600, fontSize: '0.9rem',
              border: `1px solid ${homeHover ? 'rgba(255,255,255,0.16)' : 'rgba(255,255,255,0.08)'}`,
              cursor: 'pointer', fontFamily: 'inherit',
              transition: 'color 0.15s ease, border-color 0.15s ease',
            }}
            onMouseEnter={() => setHomeHover(true)}
            onMouseLeave={() => setHomeHover(false)}
            onClick={() => navigate('/')}
          >
            Back to Home
          </button>
        </div>
      </div>
    </div>
  );
}
